import React from 'react'

import moment from 'moment'
import editImage from '../../../images/icons/edit_black.svg';
import VideoThumb from '../../video/VideoThumb'
import ThumbUpImg from '../../../images/icons/thumb_up_black.svg'
import deleteImage from '../../../images/icons/delete_forever_black.svg';
import ShowCategories from '../../ui/ShowCategories'
import arrowRight from '../../therapist/images/arrow-right.svg'
import arrowRightDark from '../../therapist/images/arrow-right-dark.svg'
import folderSVG from '../../therapist/images/folder-solid.svg'
import commentSVG from '../../therapist/images/comment-alt-solid.svg'

import DatePicker from 'react-datepicker';
import dateSVG from '../../therapist/images/calendar.svg'

//import {fetchSessions} from '../../actions/patient'
import 'react-datepicker/dist/react-datepicker.css';

const AssessmentComponent = ({
	patient,
	patient_sessions_array,
	therapy_areas,
	therapy_categories,
	videos,
	openClick,
	notifications,
	isEditable,
	children,
	handleEdit,
	handleDelete,
	toggleShowAssessment,
	filterBy,
	filter,
	filterDate,
	filterByDate,
	homework,
	toggleHomework,
}) => {
	const util = require('util')
	let now = new Date().getTime();
	// console.log(homework)
		
        //console.log(util.inspect(patient_sessions_array, false, null, true /* enable colors */))
	function displayAge(birth, target) {
		let months = target.diff(birth, 'months', true)
		let birthSpan = {
			year: Math.floor(months / 12),
			month: Math.floor(months) % 12,
			day: Math.round((months % 1) * target.daysInMonth(), 0)
		}
		// you can adjust below logic as your requirements by yourself
		if (birthSpan.year < 1 && birthSpan.month < 1) {
			return birthSpan.day + ' day' + (birthSpan.day > 1 ? 's' : '')
		} else if (birthSpan.year < 1) {
			return birthSpan.month + ' month' + (birthSpan.month > 1 ? 's ' : ' ') + birthSpan.day + ' day' + (birthSpan.day > 1 ? 's' : '')
		} else if (birthSpan.year < 2) {
			return birthSpan.year + ' year' + (birthSpan.year > 1 ? 's ' : ' ') + birthSpan.month + ' month' + (birthSpan.month > 1 ? 's ' : '')
		} else {
			return birthSpan.year + ' year' + (birthSpan.year > 1 ? 's' : '')
		}
	}

	function setSessionKey(session) {
		return session.type + '-' + session.data._id;
	}

	function setHomeworkId(session) {
		return 'homework-' + setSessionKey(session);
	}

	// patient_sessions_array = [{ type: 'assessment',    date: '2018-10-30T09:14:08.343Z',    data:      { _id: '5bd820e08e271b3fa78864de',       patientRecord:         { _id: '5b7d1f0ab6780c0014306070',          __v: 0,          patient: '5b7d1ee5b6780c001430606f',          practice: '5b507507456caf0014f7426e',          therapist: '5b61aa593288ff0f6cd60233',          created: '2018-11-06T12:59:10.531Z',          modified: '2018-10-30T11:21:40.837Z',          videosCount:            { '5a2fb22973aeb7001470c442': 1,             '5a2fa45173aeb7001470c43b': 1,             '5a2f9b8f73aeb7001470c436': 1,             '596297aa141b2bb8d70be717': 1,             '5a2f9a0f73aeb7001470c435': 1,             '596297d1141b2bb8d70be718': 1,             '595fe359141b2bb8d70be6d4': 2,             '59627a3c141b2bb8d70be6ef': 1,             '5904d55fba889a849fd646a8': 1,             '58f672af257d75d00199f69f': 1,             '587bce97ec22607ec6f62d07': 1,             '587bce04ec22607ec6f62d06': 1 },          id: '5b7d1f0ab6780c0014306070' },       __v: 0,       description: 'Testing the time and date',       internal_notes: 'Hope to see if the date is automatically saved',       patient:         { _id: '5b7d1ee5b6780c001430606f',          firstName: 'Test',          lastName: 'Tester',          createdBy: '5b507507456caf0014f7426e',          __v: 0,          dob: '2014-10-09T00:00:00.000Z',          parent: '5b6196e73288ff0f6cd55196',          picture:            { orig: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpatients%2F5b7d1ee5b6780c001430606f%2Fpatient_5b7d1ee5b6780c001430606f.jpg?alt=media&token=74d8702b-0075-430b-be20-3b3ac3a49ce2',             scaled: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpatients%2F5b7d1ee5b6780c001430606f%2Fscaled%2Fscaled_patient_5b7d1ee5b6780c001430606f.jpg?alt=media&token=ba4fdee0-10da-4b04-a9fe-087451dea451',             thumb: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpatients%2F5b7d1ee5b6780c001430606f%2Fthumb%2Fthumb_patient_5b7d1ee5b6780c001430606f.jpg?alt=media&token=2106f0df-93cc-442a-9d7c-a7a6bf648cbd' },          archived: false,          created: '2018-08-22T08:29:25.208Z',          modified: '2018-10-25T12:53:54.221Z',          therapy_areas: [],          therapists: [ '5b61aa593288ff0f6cd60233' ],          guardians: [],          id: '5b7d1ee5b6780c001430606f' },       practice:         { _id: '5b507507456caf0014f7426e',          name: 'FirstView',          HPCSA: '123456789',          owner: '5b61aa593288ff0f6cd60233',          slug: 'firstview',          tempSlug: false,          __v: 0,          logo:            { orig: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fpractice_logo_5b507507456caf0014f7426e.png?alt=media&token=2fc0180a-5599-4d93-be6d-9377969ff4ae',             scaled: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fscaled%2Fscaled_practice_logo_5b507507456caf0014f7426e.png?alt=media&token=a4455747-f588-4202-8d81-389da193210f',             thumb: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fthumb%2Fthumb_practice_logo_5b507507456caf0014f7426e.png?alt=media&token=5e753651-a344-4e6b-9705-7581bbdfb938' },          backgroundImg:            { orig: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fpractice_background_5b507507456caf0014f7426e.png?alt=media&token=559c87fc-b184-4e9f-b076-0334ec9787f7',             scaled: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fscaled%2Fscaled_practice_background_5b507507456caf0014f7426e.png?alt=media&token=1d7b3125-6f7d-4d1b-b1e4-c24d1742d781',             thumb: 'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/images%2Fpractices%2F5b507507456caf0014f7426e%2Fthumb%2Fthumb_practice_background_5b507507456caf0014f7426e.png?alt=media&token=75b9e738-a13b-4bc6-9bf8-85f4153adc61' },          approved: true,          userTypes:            { owner: false,             pendingUsers: false,             guardians: false,             parents: false,             therapists: false },          created: '2018-07-19T11:24:55.033Z',          modified: '2018-11-01T06:12:05.444Z',          availablePatients: [],          pendingUsers:            [ '5b4f38cf8f8bf3b047bf7692',             '5b549d123288ff0f6c9daedf',             '5b6196e73288ff0f6cd55196',             '5b61aa593288ff0f6cd60233',             '5b62ee603288ff0f6ce114f0',             '5b72f1c13288ff0f6c54af0f',             '5bbda9142ea00bb96909cbfc',             '5bbda9d52ea00bb96909cf7e' ],          guardians: [],          patients:            [ '5b50761c456caf0014f74270',             '5b5081ae456caf0014f74275',             '5b62eba578f5b200144e198a',             '5b7d1ee5b6780c001430606f',             '5b863f4d3b93ba001422331d',             '5b8654993b93ba001422331f',             '5b86554a3b93ba0014223321',             '5b863efb3b93ba001422331c',             '5bd82932a93cabd43bd43c76',             '5bd82aa4a93cabd43bd43c77',             '5bd84888a93cabd43bd43c7a' ],          parents:            [ '5b4f38cf8f8bf3b047bf7692',             '5b6196e73288ff0f6cd55196',             '5bbda9142ea00bb96909cbfc',             '5bbda9d52ea00bb96909cf7e',             '5b5f4a013288ff0f6cc547be',             '5b421a888f8bf3b04795beac',             '5b61aa593288ff0f6cd60233',             '5b7bd47f3288ff0f6c913545' ],          therapists:            [ '5b549d123288ff0f6c9daedf',             '5b4f38cf8f8bf3b047bf7692',             '5b62ee603288ff0f6ce114f0',             '5b61aa593288ff0f6cd60233',             '5b72f1c13288ff0f6c54af0f',             '5951405cbfe175eb3431a45a' ],          postCode: '3630',          country: 'South Africa',          state: 'Kwa-Zulu Natal',          city: 'Durban',          address2: '14 Church road',          address1: 'Suire 10 Prische house',          description: 'This is the OT description',          www: '',          mobile: '0810381210',          phone: '0312661338',          email: 'amy@hellofirstview.com',          id: '5b507507456caf0014f7426e' },       therapist:         { _id: '5b61aa593288ff0f6cd60233',          uid: 'SEVwVYec20WNZMXwPtgM2vCevGX2',          __v: 0,          email: 'wade@hellofirstview.com',          email_verified: true,          exp: 1541512736,          photoUrl: 'https://lh5.googleusercontent.com/-oYtDYsuJoXc/AAAAAAAAAAI/AAAAAAAAAAc/8i_L2YdX-wI/photo.jpg',          picture: 'https://lh5.googleusercontent.com/-oYtDYsuJoXc/AAAAAAAAAAI/AAAAAAAAAAc/8i_L2YdX-wI/photo.jpg',          sub: 'SEVwVYec20WNZMXwPtgM2vCevGX2',          user_id: 'SEVwVYec20WNZMXwPtgM2vCevGX2',          therapist: true,          owner: true,          admin: true,          terms_conditions: true,          parent: true,          modified: '2018-08-01T13:34:00.359Z',          therapistPractices: [ '5b507507456caf0014f7426e', '5bd81f67a93cabd43bd43c75' ],          ownPractices: [ '5b507507456caf0014f7426e', '5bd81f67a93cabd43bd43c75' ],          practices: [ '5b507507456caf0014f7426e' ],          tippedsSeen: [],          signedInUrl: null,          displayName: 'Wade Dunbar',          name: 'Wade Dunbar',          created: '2018-08-01T12:40:57.000Z',          id: '5b61aa593288ff0f6cd60233' },       created: null,       modified: '2018-10-30T09:14:08.343Z',       documents: [],       doa: null,       therapy_areas: [],       id: '5bd820e08e271b3fa78864de' } },{ type: 'session',    date: '2018-09-12T07:05:38.298Z',    data:      { _id: '5b98bc6cf7bd3100141d61cc',       __v: 0,       dateSent: '2018-09-12T07:12:43.100Z',       internal_notes: 'test',       parent_notes: 'test',       patient: '5b7d1ee5b6780c001430606f',       patientRecord: '5b7d1f0ab6780c0014306070',       practice: '5b507507456caf0014f7426e',       therapist:         { _id: '5b61aa593288ff0f6cd60233',          uid: 'SEVwVYec20WNZMXwPtgM2vCevGX2',          picture: 'https://lh5.googleusercontent.com/-oYtDYsuJoXc/AAAAAAAAAAI/AAAAAAAAAAc/8i_L2YdX-wI/photo.jpg',          name: 'Wade Dunbar',          created: '2018-08-01T12:40:57.000Z',          id: '5b61aa593288ff0f6cd60233' },       created: '2018-09-12T07:05:38.298Z',       modified: '2018-11-06T12:13:17.643Z',       opened: false,       sent: true,       videos_done: {},       area_notes: {},       videos: [],       internal_images: [],       images: [],       therapy_categories: [],       therapy_areas: [],       id: '5b98bc6cf7bd3100141d61cc' } }]
	// therapy_areas = [{},{}]
	// console.log(therapy_areas.length)

	return Object.keys(therapy_areas).length ? <div>
		{children}
		{/* FILTER */}
		<div className="typeAndDateFilter">
			<div className="typeFilter">
				<label htmlFor="typeFilter">Type:</label>
				<select name="typeFilter" id="typeFilter" onChange={filterBy} value={filter}>
					<option value="all">All</option>
					<option value="sessions">Sessions</option>
					<option value="assessments">Assessments</option>
				</select>
			</div>
			<DatePicker
				// readOnly={true}
				popperPlacement="bottom-end"
				selected={filterDate}
				onChange={filterByDate}
				placeholderText="Date Range"
				dateFormat="YYYY/MM/DD"
				showYearDropdown
			/>
			{/* <div className="dateFilter">
				<img className="icon" src={dateSVG} />
				<input type="date" />
			</div> */}
		</div>
		{/* FILTER */}
		{
			patient_sessions_array.length ? patient_sessions_array.map(session => <div key={setSessionKey(session)}>
				{/* <div className="spacerTopBottom"></div> */}

				{/* ASSESMENT CARD */}
				{session.type === 'assessment' && <div>
					<ul className="md-list card assesmentCard marginless">
						<li className="card-header row">
							<div className="patientSessionOrAssesmentIcon">
								<span>A</span>
							</div>
							<div className="headerInfo">
								<p>{(now - (Date.parse(session.date) / 86400000)) > 2 ?
									moment(session.date).format('ddd Do of MMM YYYY') : moment(session.date).fromNow()}
								</p>
								<small>Therapist: {session.data.therapist.name} | Patient Age: {displayAge(moment(session.data.patient.dob), moment(session.date))}</small>
							</div>
							<div className="headerAction">
								<a className="link padding textWhite" onClick={() => toggleShowAssessment(session.data)}>OPEN</a>
							</div>
						</li>
						<li className="categoriesSection">
							<div className="catogories">
								<ShowCategories
									therapy_areas={session.data.therapy_areas.map(areaId => therapy_areas[areaId])}
									therapy_categories={therapy_categories} />
							</div>
							<div className="commentAndDocs">
								<div className="documents">
									<img src={folderSVG} />
									<p>{session.data.documents.length} Documents</p>
								</div>
							</div>
						</li>
					</ul>
					<div className="hrAssesment">
						<span></span>
					</div>
				</div>}
				{/* ASSESMENT CARD */}

				{/* SESSION CARD */}
				{session.type === 'session' && <div>
					<ul className="md-list sessionCard card marginless">
						<li className="card-header row">
							<div className="patientSessionOrAssesmentIcon">
								<span>S</span>
							</div>
							<div className="headerInfo">
								<p>
									{
										(!session.data.sent && !isEditable) && <span className="">Draft - </span>
									}
									{(now - (Date.parse(session.data.created) / 86400000)) > 2 ?
									moment(session.data.created).format('ddd Do of MMM YYYY h:mm a') : moment(session.data.created).fromNow()}
								</p>
								<small>Therapist: {session.data.therapist.name}</small>
							</div>
							<div className="headerAction">
								
								{
									(session.data.sent || !isEditable) && <a className="link padding" onClick={() => {
										openClick(session.data)
									}
									}>OPEN</a>
								}
								{(handleEdit && (!session.data.sent && isEditable)) && <div
									onClick={() => { handleEdit(session.data) }}
									className="edit padding icon link">
									<img src={editImage} alt="Edit" />
								</div>
								}
								{(handleDelete && (!session.data.sent && isEditable)) && <div
									onClick={() => { handleDelete(session.data._id) }}
									className="edit padding icon link">
									<img src={deleteImage} alt="Delete" />
								</div>
								}
							</div>
						</li>
						{/* <li className="card-content">
					<p>{session.data.internal_notes}</p>
				</li> */}
						<li>

							<ShowCategories
								therapy_areas={session.data.therapy_areas.map(areaId => therapy_areas[areaId])}
								therapy_categories={therapy_categories} />
						</li>
						<li className="homeWorkSection">
							<div onClick={() => { toggleHomework(setHomeworkId(session)) }} className="md-subhead"><a >Homework Areas</a></div>
							<div id={setHomeworkId(session)} className={homework === setHomeworkId(session) ? "video-grid show grid horizontal-row" : "video-grid grid horizontal-row"}>
								<div className="videoContainer">
									{session.data.videos.map(videoId => <div className="thumb" key={videoId}>
										<div className="card marginless">
											{videos[videoId] && <VideoThumb class="min-video" video={videos[videoId]} />}
											{session.data.videos_done[videoId] && <img alt="Avatar" src={ThumbUpImg} style={{
												height: '18px',
												position: 'absolute',
												right: '4px',
												bottom: '4px'
											}} />}
										</div>
									</div>)}
								</div>
							</div>
						</li>
						{notifications[session.data._id] > 0 && <div className="notification link" onClick={() => {
							openClick(session.data)
						}
						}>
							{notifications[session.data._id]}
						</div>}
					</ul>
					<div className="hrAssesment">
						<span></span>
					</div>
				</div>}
			</div>)
				:
				<div><p>No sessions yet</p></div>
		}
	</div>
		: <p>Loading...</p>;
	{/* SESSION CARD */ }

}

AssessmentComponent.defaultProps = {
	patient: {},
	notifications: {},
	patient_sessions_array: [],
	therapy_areas: {},
	videos: {},
	editButton: false
}

export default AssessmentComponent



// WEBPACK FOOTER //
// ./src/components/practice_admin/patient/AssessmentComponent.jsx